<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="record-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="record-view">
                        <div class="table-head"></div>
                        <div class="table-view">
                            <vuescroll>
                                <table>
                                    <!-- <thead>
                                        <tr>
                                            <td>昵称</td>
                                            <td>申请时间</td>
                                            <td></td>
                                        </tr>
                                    </thead> -->
                                    <tbody>
                                        <tr v-for="(item,index) in record_list" :key="index">
                                            <td style="width: 120px;"><div class="text-overflow-1">{{ item.nickName }}</div></td>
                                            <td class="time">{{ item.applyTime.slice(5) }}</td>
                                            <td>
                                                <div class="tools flex" v-if="item.review == 0">
                                                    <div class="u-btn agree" @click="apply_agree(item.code,item.nickName,item.id)"></div>
                                                    <div class="u-btn dismiss"  @click="apply_agree(item.code,item.nickName,item.id,2)"></div>
                                                </div>

                                                <div class="result" v-else>
                                                    <p :class="{'agree' : item.review == 1 , 'ban' : item.review == 2}">{{ item.review == 1 ? '已同意' : '已拒绝' }}</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </vuescroll>
                        </div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.record-modal{
    width: 650px;
    height: 404px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.title{
    width: 333px;
    height: 41px;
    margin: 0 auto 25px;
    background-image: url(~@/assets/images/modal/title-record.png);    
}

.table-view{
    height: 310px;
}

.table-view{
    width: 620px;
    margin-left: 50px;
    font-size: 20px;
}

table{
    width: 600px;
    margin: 0 auto;
    text-align: center;
    color: #daefff;
    border-collapse: collapse;
}

thead{
    td{
        font-size: 20px;
        color: #daefff;
        background-color: #f0ecea;
    }
}

tbody td{
    height: 40px;
}

tr{
    font-size: 20px;
    color: #daefff;    
    margin-bottom: 20px;
}

.time{
    // color: #a7968f;
}

.result{
    width: 160px;
    text-align: center;

    .agree{
        color: #2ed474;
    }

    .ban{
        color: #a8a3a8;
    }
}

.u-btn.agree{
    width: 72px;
    height: 26px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/btn-agree.png);  
}

.u-btn.dismiss{
    width: 72px;
    height: 26px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/btn-ban.png);  
}
</style>

<script>
import { apiApplyAgree } from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            text : '',
            record_list : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        console.log(this.record_list);
    },           
    methods: {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
        closeModal(){
            this.destroyElement()
        },
        apply_agree(code,name,id ,type = 1){
            this.destroyElement();
            this.$team_agree({code : code , player_data : name , id : id , type : type});
        },       
    },    
}
</script>